var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgEllipsisVertical = function SvgEllipsisVertical(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    className: "ellipsis-vertical_svg__ionicon",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 48
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 416,
    r: 48
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 96,
    r: 48
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEllipsisVertical);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;